import log from 'loglevel';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Loader } from '../../components/Loader';
import { useGetMatchPreview } from '../../hooks/useMatch';
import STRING_KEYS from '../../language/keys';
import { PageErrorBanner } from '../../components/PageErrorBanner';
import { style } from './style';

const TAG = '[MATCH_PREVIEW_PAGE]';

export const MatchPreviewPage = (): JSX.Element => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeSrc, setIframeSrc] = useState<string>('');

  const { accountId = '', positionId = '', matchId = '' } = useParams();
  const { t: translate } = useTranslation();

  const getOrigin = (url: string): string => {
    // https://stackoverflow.com/a/1420902
    const parts = url.split('/');
    const protocol = parts[0];
    const hostAndPort = parts[2];

    return `${protocol}//${hostAndPort}`;
  };

  const setIframeContent = (data: MatchResponse) => {
    if (iframeRef?.current?.contentWindow) {
      if (iframeSrc) {
        iframeRef.current.contentWindow.postMessage(
          data,
          getOrigin(iframeSrc),
        );
      }
    }
  };

  const {
    data: matchPreviewData,
    isLoading,
    error,
  } = useGetMatchPreview(accountId, positionId, matchId, true, (data) => {
    if (!data.matchPreviewUrl) {
      log.error(TAG, 'match preview url is missing in response or an empty string');

      return;
    }

    setIframeSrc(data.matchPreviewUrl);
    setIframeContent(data.match);
  });

  const handleIframeLoad = () => {
    if (matchPreviewData?.match) {
      setIframeContent(matchPreviewData.match);
    }
  };

  const defineLoading = () => {
    if (!isLoading) {
      return null;
    }

    return <Loader top="45%" left="45%" />;
  };

  const defineError = () => {
    if (!error) {
      return null;
    }

    log.error(TAG, 'failed to load match-preview data', error);

    return <PageErrorBanner />;
  };

  // if (!iframeSrc) {
  //   log.error(TAG, 'match preview url does NOT exist');

  //   return <PageErrorBanner message={ translate(STRING_KEYS.CANNOT_LOAD_PREVIEW_URL) } />;
  // }

  return (
    <>
      {defineLoading()}
      {defineError()}

      {!!iframeSrc && (
        <iframe
          onLoad={ handleIframeLoad }
          ref={ iframeRef }
          src={ iframeSrc }
          title={ translate(STRING_KEYS.MATCH_PREVIEW) }
          style={ style.iframe }
        />
      )}
    </>
  );
};
